/* eslint-disable @typescript-eslint/no-explicit-any */
import { omitObject, pickObject } from '@client/new/helpers/general';
import {
  LegacyExercise,
  LegacyHIIT,
  LegacyTabata,
  Media,
} from '../../workout/models/workout.domain';
import { HIIT, Tabata, ParentExercise, SubExercise } from './workouts.domain';
import { LegacyWorkoutFormValues } from '../../workout/models/workoutEdit.model';

const toLegacyExercise = (e: SubExercise): LegacyExercise => ({
  ...omitObject(e.value as any as LegacyExercise, ['sets', 'uuid']),
  type: 2,
  media: e.value.media as Media,
  sets: e.value.sets.map((s) => ({
    time: s.time,
    rest: s.rest,
    reps: s.rep.type === 'AMRAP' ? [619, 'reps'] : [s.rep.value, 'reps'],
  })),
});

export const toLegacyAutoplay = (
  e: ParentExercise,
): LegacyHIIT | LegacyTabata => ({
  ...pickObject(e.value, ['description', 'id', 'name', 'rounds']),
  uuid: e.value.id,
  exercises: e.value.exercises.map(toLegacyExercise),
  type: e.type === 'HIIT' ? 11 : 10,
  longRest: e.value.longRest,
  rounds: e.value.rounds,
});

export const combineWorkoutWithLegacyData = (
  legacyData: LegacyWorkoutFormValues,
  newData: ParentExercise[],
): LegacyWorkoutFormValues => {
  const exercises = (legacyData.exercises as LegacyExercise[]).map((e) => {
    const el = newData.find((n) => n.value.id === e.id);
    return el ? toLegacyAutoplay(el as HIIT | Tabata) : e;
  });
  return { ...legacyData, exercises };
};
